/**
 * Debt Recovery - Billing Module
 * Track and manage outstanding debts and collections
 */

import React from 'react';
import { makeStyles, Text, Card, tokens } from '@fluentui/react-components';
import { MoneyRegular } from '@fluentui/react-icons';

const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    padding: '24px',
    maxWidth: '1400px',
    margin: '0 auto',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    marginBottom: '8px',
  },
  headerIcon: {
    fontSize: '32px',
    color: tokens.colorBrandForeground1,
  },
  headerText: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },
  title: {
    fontSize: '24px',
    fontWeight: '600',
    color: tokens.colorNeutralForeground1,
  },
  subtitle: {
    fontSize: '14px',
    color: tokens.colorNeutralForeground3,
  },
  card: {
    padding: '32px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '300px',
    gap: '16px',
  },
  placeholderIcon: {
    fontSize: '64px',
    color: tokens.colorNeutralForeground4,
  },
  placeholderText: {
    fontSize: '16px',
    color: tokens.colorNeutralForeground3,
    textAlign: 'center',
  },
});

const DebtRecoveryFluentUI: React.FC = () => {
  const styles = useStyles();

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <MoneyRegular className={styles.headerIcon} />
        <div className={styles.headerText}>
          <Text className={styles.title}>Debt Recovery</Text>
          <Text className={styles.subtitle}>
            Track and manage outstanding payments and collections
          </Text>
        </div>
      </div>

      <Card className={styles.card}>
        <MoneyRegular className={styles.placeholderIcon} />
        <Text className={styles.placeholderText}>
          Debt recovery functionality coming soon.
          <br />
          This module will help you track overdue payments and manage collection efforts.
        </Text>
      </Card>
    </div>
  );
};

export default DebtRecoveryFluentUI;
